import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import tailwindConfig from "twConfig";
import { computed } from "vue";

interface Props {
  items: Array<{
    data: Array<Array<number>>;
    color: string;
  }>;
  dateTimeFormat?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VChart',
  props: {
    items: { default: () => [
    {
      data: [],
      color: "#FF5C00",
    },
  ] },
    dateTimeFormat: { default: "YMD" }
  },
  setup(__props: any) {

const props = __props;

const {
  extend: { fontSize },
} = tailwindConfig.theme;

const [labelSize] = fontSize.sm;

const format = computed(() => {
  return props.dateTimeFormat === "YMD" ? "{value:%Y/%m/%d}" : "{value:%Y/%m/%d %H:%M}";
});

const chartOptions = computed(() => {
  let series = props.items.map((item) => {
    return {
      data: item.data,
      color: item.color,
      fillColor: {
        linearGradient: {
          x1: 0,
          x2: 0,
          y1: 0,
          y2: 1,
        },
        stops: [
          [0, item.color],
          [1, "rgba(255,255,255,0)"],
        ],
      },
    };
  });

  return {
    chart: {
      type: "areaspline",
    },
    series: series,
    title: false,
    yAxis: {
      title: false,
      labels: {
        style: {
          fontSize: labelSize,
        },
      },
    },
    xAxis: {
      title: false,
      type: "datetime",
      labels: {
        rotation: -45,
        align: "right",
        format: format.value,
        style: {
          fontSize: labelSize,
        },
      },
    },
    legend: {
      enabled: false,
    },
  };
});

return (_ctx: any,_cache: any) => {
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_openBlock(), _createBlock(_component_highcharts, {
    options: chartOptions.value,
    class: "chart"
  }, null, 8, ["options"]))
}
}

})